import React, { ReactNode, useState } from 'react';
import styled from 'styled-components';
import { Tab, TabList, TabPanel } from '../../../../../widgets/ztabs';
import { ComposerTabs } from '../composer-editors/composerWorkspace';
import { INSPECTOR_BACKGROUND } from '../treeRowLook';

// LE TAB DELL'INSPECTOR, LE STESSE DEL COMPOSER (round 4, pacchetto C). I capitoli di una colonna
// lunga — General, Settings; Surface, Advanced — diventano tab: si vede un capitolo alla volta, e il
// nome del capitolo è il comando per andarci invece di una parola da cercare scorrendo.
//
// La barra resta ferma in cima mentre le proprietà scorrono: il corpo dell'Inspector ha dodici pixel
// di rientro, e la barra li riprende per arrivare ai bordi come quella del Composer.
const Tabs = styled(ComposerTabs)`
    flex: none;

    .react-tabs__tab-list {
        position: sticky;
        top: -12px;
        z-index: 2;
        width: calc(100% + 12px);
        margin: 0 0 12px -12px;
        /* GRIGIA COME LA COLONNA, come nel Composer (utente, 2026-10-15): piena, perché ferma in cima deve
           coprire le proprietà che le scorrono sotto. */
        background: ${INSPECTOR_BACKGROUND};
    }

    &:first-child > .react-tabs__tab-list {
        margin-top: -12px;
    }

    /* Dentro c'è un elenco che cresce, non una vista da ritagliare: un menu aperto in una card
       deve poter uscire dal bordo della tab. */
    .react-tabs__tab-panel {
        overflow: visible;
    }
`;

export type PropertiesPanelTab = {
    id: string;
    label: ReactNode;
    content: ReactNode;
};

// L'ULTIMA TAB SCELTA, PER GENERE DI SOGGETTO: passando da una luce all'altra si resta su Settings,
// come nel prototipo. Vive quanto la pagina, ed è giusto: è un'abitudine della sessione, non una
// preferenza da salvare.
const lastTab = new Map<string, string>();

/** `memoryKey` raccoglie i soggetti che condividono la tab scelta: tutte le luci, tutti i materiali. */
export const PropertiesPanelTabs: React.FC<{ tabs: PropertiesPanelTab[]; memoryKey: string }> = ({ tabs, memoryKey }) => {
    const [active, setActive] = useState(() => lastTab.get(memoryKey));
    // Una tab che per questo soggetto non c'è — un Empty non ha materiali — riporta alla prima.
    const index = Math.max(
        0,
        tabs.findIndex((tab) => tab.id === active)
    );

    return (
        <Tabs
            selectedIndex={index}
            onSelect={(next) => {
                const id = tabs[next]?.id;
                if (!id) return;
                lastTab.set(memoryKey, id);
                setActive(id);
            }}
        >
            <TabList>
                {tabs.map((tab) => (
                    <Tab key={tab.id}>{tab.label}</Tab>
                ))}
            </TabList>
            {tabs.map((tab) => (
                <TabPanel key={tab.id}>{tab.content}</TabPanel>
            ))}
        </Tabs>
    );
};
